export default "__VITE_ASSET__4g0lxAFB__"